import actionTypes from './type';

export const showConfirm = (
  submit,
  title = 'Chắc chắn xóa',
  message = 'Vui lòng xác nhận thao tác của bạn!',
) => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CONFIRM, submit, title, message });
  };
};
export const clear = () => {
  return (dispatch) => {
    dispatch({ type: actionTypes.CLEAR });
  };
};
